import styled from 'styled-components';

export const RelatoriosContainer = styled.div`
  width: 100%;
`;

export const RelatoriosContent = styled.div`
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  gap: 16px;
  flex-grow: 1;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 24px;
`;

export const TableContainer = styled.div`
  margin-top: 24px;
  overflow-x: auto;
`;

export const ErrorContainer = styled.div`
  color: ${({ theme }) => theme.dangerColor};
  margin-top: 16px;
  padding: 12px;
  background-color: ${({ theme }) => theme.dangerLightColor || '#ffeeee'};
  border-radius: 4px;
  margin-bottom: 24px;
`;

export const ChartContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 24px;
  width: 100%;
`;

export const ChartWrapper = styled.div`
  background-color: ${({ theme }) => theme.white};
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ChartTitle = styled.h3`
  color: ${({ theme }) => theme.primaryColor};
  margin-bottom: 16px;
  text-align: center;
`;

export const NoDataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  width: 100%;
  background-color: ${({ theme }) => theme.lightGray || '#f8f9fa'};
  color: ${({ theme }) => theme.gray};
  border-radius: 8px;
  font-size: 16px;
`;

export const LegendText = styled.span`
  color: ${({ theme }) => theme.textColor};
  font-weight: 500;
`;

export const SummaryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

export const SummaryCard = styled.div`
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.borderColor || '#e0e0e0'};
  border-left: 4px solid ${({ theme }) => theme.primaryColor};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const SummaryLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.gray || '#6c757d'};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const SummaryValue = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${({ theme }) => theme.textColor};
`;

export const StatusBadge = styled.span<{ status: string }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  background-color: ${({ status, theme }) => {
    switch (status) {
      case 'APROVADA':
        return theme.successColor || '#28a745';
      case 'REJEITADA':
        return theme.dangerColor || '#dc3545';
      case 'CANCELADA':
        return theme.gray || '#6c757d';
      case 'PENDENTE':
      default:
        return theme.warningColor || '#ffc107';
    }
  }};
  color: #fff;
`;

export const ActionLink = styled.span`
  color: ${({ theme }) => theme.primaryColor};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  max-width: 100%;
`;

export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
`;

export const ImagePlaceholder = styled.div`
  padding: 40px;
  color: ${({ theme }) => theme.gray};
  text-align: center;
`;
